import React from 'react';
import AnimatedSection from '../common/AnimatedSection';
import LogoCarousel from './LogoCarousel';

const TestimonialsSection = () => {
  // Sample company logos data
  const companyLogos = [
    {
      src: process.env.PUBLIC_URL + '/img/entreprise/BCLIM.jpg',
      alt: 'Entreprise 1'
    },
    {
      src: process.env.PUBLIC_URL + '/img/entreprise/connectsecurityGo.png',
      alt: 'Entreprise 2'
    },
    {
      src: process.env.PUBLIC_URL + '/img/entreprise/maquarella.png',
      alt: 'Entreprise 3'
    },
    {
      src: process.env.PUBLIC_URL + '/img/entreprise/cuvaeau-logo.png',
      alt: 'Entreprise 4'
    },
    {
      src: process.env.PUBLIC_URL + '/img/entreprise/logo.png',
      alt: 'Entreprise 5'
    },
    
  ];


  return (
    <section className="py-24 bg-gradient-to-br from-blue-50 to-white">
      <div className="container mx-auto px-4">
        <AnimatedSection className="text-center mb-12" direction="up">
          <h2 className="section-title mb-4">Ils nous font confiance</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8 leading-relaxed">
            Découvrez les entreprises qui nous ont choisis pour développer leur présence en ligne et transformer leur vision en réalité numérique.
          </p>
        </AnimatedSection>

        {/* Logo Carousel */}
        <div className="mb-8">
          <LogoCarousel logos={companyLogos} />
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;